const BASE_URL = "https://test.dgfuturetech.in";

function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

function mapJobOpening(job) {
  return {
    id: job.name,
    title: job.job_title,
    location: job.location,
    jobType: job.employment_type,
    custom_experience: job.custom_experience || "Not specified",
    //openPositions: job.vacancies || 1,
    description: stripHtml(job.description || ""),
    skills: job.skills || [],
    department: job.department,
    detailUrl: `https://test.dgfuturetech.in/${job.route}`,
    applyUrl: `https://test.dgfuturetech.in/job_application/new?job_title=${encodeURIComponent(job.name)}`,
  };
}

export async function fetchJobOpenings() {
  const res = await fetch(
    // `${BASE_URL}/api/method/dgfuturetechwebsite.api.jobs.get_published_jobs`
    `${BASE_URL}/api/method/custom_erp.api.jobs.get_published_jobs`
  );
  if (!res.ok) throw new Error(`Failed to load jobs (${res.status})`);
  const data = await res.json();
  return (data.message || []).map(mapJobOpening);
}

export async function fetchJobOpening(name) {
  const res = await fetch(
    // `${BASE_URL}/api/method/dgfuturetechwebsite.api.jobs.get_job_opening?name=${encodeURIComponent(name)}`
    `${BASE_URL}/api/method/custom_erp.api.jobs.get_job_opening?name=${encodeURIComponent(name)}`

  );
  if (!res.ok) throw new Error(`Failed to load job (${res.status})`);
  const data = await res.json();
  return mapJobOpening(data.message);
}